.select {
  min-height: 2.25rem;
  max-width: 100%;
  padding: 0 var(--space-2);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  background: var(--color-input);
  color: var(--color-text);
  font: inherit;
}

.matrix {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(15rem, 1fr));
  gap: var(--space-3);
}

.group {
  margin: 0;
  padding: var(--space-2) var(--space-3);
  border: 1px solid var(--color-divider);
  border-radius: var(--radius-md);
}

.group legend {
  padding: 0 var(--space-1);
  font-weight: 600;
}

.permission {
  display: flex;
  gap: var(--space-2);
  align-items: flex-start;
  min-height: 2rem;
  padding: var(--space-1) 0;
  font-size: var(--font-size-sm);
}

.changed {
  font-weight: 600;
}

.impact {
  padding: var(--space-3);
  border-radius: var(--radius-md);
  background: color-mix(in srgb, var(--color-warning) 18%, transparent);
}

.impactHead {
  margin: 0 0 var(--space-2);
  font-weight: 600;
}

.impactList {
  margin: 0;
  padding-inline-start: var(--space-4);
  font-size: var(--font-size-sm);
}

.muted {
  margin: 0;
  color: var(--color-text-muted);
  font-size: var(--font-size-sm);
}

.stack {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.inline {
  display: flex;
  gap: var(--space-2);
  align-items: flex-end;
  flex-wrap: wrap;
}

.inline > label {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  font-size: var(--font-size-sm);
  font-weight: 500;
}

/* The approval checkbox sits on the same baseline as the 2.5rem inputs next to it. */
.inline > label.permission {
  flex-direction: row;
  align-items: center;
  min-height: 2.5rem;
  font-weight: 400;
}

.list {
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  list-style: none;
}

.row {
  display: flex;
  gap: var(--space-3);
  align-items: center;
  justify-content: space-between;
  min-height: 2.75rem;
  padding: var(--space-2) 0;
  border-bottom: 1px solid var(--color-divider);
  flex-wrap: wrap;
}

.rowMain {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.rowMeta {
  color: var(--color-text-muted);
  font-size: var(--font-size-xs);
}

.rowActions {
  display: flex;
  gap: var(--space-2);
  align-items: center;
  flex-wrap: wrap;
}

.secret {
  display: flex;
  gap: var(--space-2);
  align-items: center;
  padding: var(--space-2) var(--space-3);
  border-radius: var(--radius-md);
  background: color-mix(in srgb, var(--color-success) 14%, transparent);
  font-size: var(--font-size-sm);
  overflow-wrap: anywhere;
}

.secret code {
  min-width: 0;
  user-select: all;
}

.transferSides {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-1) var(--space-3);
  font-size: var(--font-size-xs);
  color: var(--color-text-muted);
}

.transferSides [data-approved='true'] {
  color: var(--color-success, var(--color-text));
}

.nominate {
  display: inline-block;
  min-width: 12rem;
}

.fieldError {
  margin: 0;
  color: var(--color-danger);
  font-size: var(--font-size-sm);
}
